import React, { Component } from 'react';
import { init } from './../libs/tabs.js';

class Tabs extends Component {
	componentWillMount() {
		init();
	}

	render() {
		return (
			<div id="tabs" />
		);
	}
}

export default Tabs;



// WEBPACK FOOTER //
// ./mobile-core/src/components/tabs.js